import React from 'react';
import type { LowStockItem } from '../warehouseDashboardTypes';
import styles from './LowStockAlerts.module.css';

interface LowStockAlertsProps {
  items: LowStockItem[];
}

export const LowStockAlerts: React.FC<LowStockAlertsProps> = ({ items }) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.heading}>Low Stock Alerts</h3>
      <div className={styles.list}>
        {items.map((item) => (
          <div
            key={item.id}
            className={`${styles.alertItem} ${styles[item.severity === 'CRITICAL' ? 'critical' : 'low']}`}
          >
            <div className={styles.alertContent}>
              <span className={styles.productName}>{item.productName}</span>
              <span className={styles.stockInfo}>
                Current: {item.currentStock} | Min: {item.minStock}
              </span>
            </div>
            <span className={`${styles.severityBadge} ${styles[`badge_${item.severity === 'CRITICAL' ? 'critical' : 'low'}`]}`}>
              {item.severity}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
